import React from 'react';
import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { ProblemSectionProps } from '../../../@types/transactions';

const ProblemSection: React.FC<ProblemSectionProps> = ({
  values,
  touched,
  errors,
  getFieldProps,
  setFieldValue,
  problems
}) => (
  <>
    <Typography variant="h6" gutterBottom>
      Problem
    </Typography>

    <Stack direction="row" spacing={2}>
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.ProblemIndicated}
              onChange={(event) => {
                const isChecked = event.target.checked;
                setFieldValue && setFieldValue('ProblemIndicated', isChecked);
                if (!isChecked) {
                  setFieldValue && setFieldValue('ProblemDetail', null);
                }
              }}
            />
          }
          label="Problem Indicated"
        />
      </FormControl>
    </Stack>

    {values.ProblemIndicated && (
      <Stack direction="row" spacing={2}>
        <FormControl fullWidth>
          <Autocomplete
            options={problems}
            getOptionLabel={(option: any) => option.value || ''}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            value={
              problems.find(
                (option: { value: string; id: number }) => option.value === values.ProblemDetail
              ) || null
            }
            onChange={(event, newValue) => {
              setFieldValue && setFieldValue('ProblemDetail', newValue ? newValue.value : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Problem Description"
                error={Boolean(touched.ProblemDetail && errors.ProblemDetail)}
                helperText={touched.ProblemDetail && errors.ProblemDetail}
              />
            )}
          />
        </FormControl>
      </Stack>
    )}

    {values.ProblemIndicated && values.ProblemDetail === 'OTHER' && (
      <Stack direction="row" spacing={2}>
        <TextField
          fullWidth
          label="Description"
          multiline
          rows={3}
          {...getFieldProps('GeneralNotes')}
          error={Boolean(touched.GeneralNotes && errors.GeneralNotes)}
          helperText={touched.GeneralNotes && errors.GeneralNotes}
        />
      </Stack>
    )}
  </>
);

export default ProblemSection;
